import { createSelector } from "reselect";

export const getAllWeeklyUserCapacityData = (state) => state.userWorkweeks;

export const getAllWeeklyUserCapacities = createSelector(getAllWeeklyUserCapacityData, (userWorkweeks) => {
  const usersCapacity = {};
  Object.keys(userWorkweeks).forEach((key) => {
    const { capacity } = userWorkweeks[key];
    usersCapacity[key] = capacity;
  });
  return usersCapacity;
});

export const getWeeklyUserCapacityArrayById = (id) =>
  createSelector(getAllWeeklyUserCapacities, (allUsersCapacity) => allUsersCapacity[id] || []);

export const getUserWorkweekById = createSelector(
  (state, userId) => userId,
  getAllWeeklyUserCapacityData,
  (userId, allUsersCapacity) => allUsersCapacity[userId]
);
